import axios from "axios";
import { IDownloadExpiredPracticeFileReturn, IDownloadExpiredPracticeParams, IExpiredActionExecuteParams, IExpiredPracticeActionDatesParams, IExpiredPracticeSaveRecoveryCompanyParams, IGetPracticesListParams, IOFindExpiredConfigurationParams, PracticesDomains, PracticesListSummaryReturn } from "../models/models";

// PATHS
const PRACTICES_LIST = "/expired/search";
const PRACTICES_LIST_SUMMARY = "/expired/summary";
const PRACTICES_DOMAINS = "/expired/domains";
const CLOSE_PRACTICES = "/expired/close";
const DOWNLOAD_PIVOT = "/expired/pivot";
const DOWNLOAD_PRACTICE_LIST = "/expired/basicexport";
const DOWNLOAD_PRACTICE_LIST_COUNT = "/expired/export-count";

const EXPIRED_PRACTICE_FIND_BY_ID= '/expired/findById/{id}';
const EXPIRED_PRACTICE_ACTION_HISTORY_BY_ID= '/expired/findActionHistoryById/{id}';
const EXPIRED_ATTACHMENTS_LIST = "/expiredAttachment/{expiredId}";
const EXPIRED_ATTACHMENTS_TYPES = "/expiredAttachment/types";
const EXPIRED_ATTACHMENTS_DOWNLOAD = "/expiredAttachment/getblob/{id}";
const EXPIRED_ATTACHMENTS_UPLOAD = "/expiredAttachment/addattachment";
const EXPIRED_ATTACHMENT_DELETE_BY_ID = "/expiredAttachment/delete/{id}";
const EXPIRED_PRACTICE_UPDATE_ACTION_DATES = '/expired/updateActionDates/{id}';
const EXPIRED_PRACTICE_ADD_TO_WATCHLIST = '/expired/setblacklist/{id}';
const EXPIRED_PRACTICE_FIND_RECOVERY_COMPANY = '/expired/findRecoveryCompany';
const EXPIRED_PRACTICE_SAVE_RECOVERY_COMPANY = '/expired/saveExpiredRecoveryCompany/{id}';
const GET_EXPIRED_FROM_RA_CODE = 'expired/getExpiredFromRaCode/{raCode}';
const INSERT_EXPIRED_FROM_RA_CODE = 'expired/insertExpiredfromRAcode';
const EXPIRED_CONFIGURATION = "/expiredConfiguration/find";
const EXPIRED_CONFIGURATION_UPDATE = "/expiredConfiguration/update";
const EXPIRED_ACTIONS_GET = "expiredAction/getExpiredActions";
const EXPIRED_ACTIONS_FOR_VIEW = "expiredAction/getExpiredActionsForView";
const EXPIRED_ACTIONS_EXECUTE = "expiredAction/execute";
const EXPIRED_MESSAGE_TEMPLATE = "expiredMessageTemplate/getByAction";

const EXPIRED_GENERATE_WARNING_LETTER= '/expired/generateLawsuitPDF';
/** Getch details for Practice Detail Page */
const fetchExpiredPricticeById: any = async (id: string) => {
    const path = EXPIRED_PRACTICE_FIND_BY_ID.replace('{id}', id);
    const response =  await axios.get(path);
    return response.data;
}

const fetchExpiredPracticeActionHistoryById: any = async (id: string) => {
    const path = EXPIRED_PRACTICE_ACTION_HISTORY_BY_ID.replace('{id}', id);
    const response =  await axios.get(path);
    return response.data;
}

const updateActionDates = async (params: IExpiredPracticeActionDatesParams) => {
    const path = EXPIRED_PRACTICE_UPDATE_ACTION_DATES.replace('{id}', params.id);
    const response = await axios.post(path, {actionDates: params.actionDates});
    return response.data;
}

const addToWatchlist = async (id: string) => {
    const path = EXPIRED_PRACTICE_ADD_TO_WATCHLIST.replace('{id}', id);
    const response = await axios.post(path);
    return response.data;
}

const findRecoveryCompany = async () => {
    const response = await axios.get(EXPIRED_PRACTICE_FIND_RECOVERY_COMPANY);
    return response.data;
}

const saveRecoveryCompany = async (params: IExpiredPracticeSaveRecoveryCompanyParams) => {
    const path = EXPIRED_PRACTICE_SAVE_RECOVERY_COMPANY.replace('{id}', params.id);
    const response = await axios.post(path, params.recoveryCompany)
    return response.data;
}

/** Search */
const fetchPracticesList = async (req: IGetPracticesListParams): Promise<any> => {
    const response =  await axios.post(PRACTICES_LIST, req);
    return response.data;
}

const fetchPracticesListSummary = async (req: IGetPracticesListParams): Promise<PracticesListSummaryReturn> => {
    const response =  await axios.post(PRACTICES_LIST_SUMMARY, req);
    return response.data;
}

const getPracticesDomains = async (): Promise<PracticesDomains> => {
     const response =  await axios.get(PRACTICES_DOMAINS);
     return response.data?.data;
}

const closeSelectedPractices = async (req: string[]) => {
    const response = await axios.put(CLOSE_PRACTICES, null, {params: {expiredCodes: req.join(",")}});
    return response.data;
}

const downloadPivot = async (): Promise<IDownloadExpiredPracticeFileReturn> => {
    const response = await axios.post(
        DOWNLOAD_PIVOT,
        null,
        {
            responseType: "arraybuffer"
        }
    );

    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename=(.*)/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};

const downloadExpiredPractices = async (req: IDownloadExpiredPracticeParams): Promise<IDownloadExpiredPracticeFileReturn> => {
    const response = await axios.post(
        DOWNLOAD_PRACTICE_LIST,
        req,
        {
            responseType: "arraybuffer"
        }
    );

    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition.match(/filename=(.*)/)?.[1] ?? 'unknown';
    return {
        file: response.data,
        fileName
    };
};

const downloadExpiredPracticesCount = async (req: IGetPracticesListParams): Promise<number> => {
    const response = await axios.post(DOWNLOAD_PRACTICE_LIST_COUNT, req);
    return response.data;
}

const getExpiredActionsForView = async () => {
    const response = await axios.get(EXPIRED_ACTIONS_FOR_VIEW);
    return response.data;
} 

/** Expired Configuration */
const findExpiredConfiguration = async (req: { tenant: string }): Promise<any> => {
    const response =  await axios.get(EXPIRED_CONFIGURATION, { params: req });
    return response.data;
}

const updateExpiredConfiguration = async (req: IOFindExpiredConfigurationParams): Promise<any> => {
    

    const response =  await axios.post(EXPIRED_CONFIGURATION_UPDATE, { configurationCompanyDTO: req });
    return response.data;
}

/** Expired Actions */
const getExpiredActions = async (statusId: string) => {
    const response = await axios.get(EXPIRED_ACTIONS_GET, {params: { statusId }});
    return response.data;
} 

const getExpiredActionsMessageTemplate = async (expiredCodes: string[], actionType: string) => {
    const response = await axios.get(EXPIRED_MESSAGE_TEMPLATE, {params: { expiredCodes: expiredCodes.join(","), actionType }});
    return response.data;
} 
 
const executeExpiredAction = async (req: IExpiredActionExecuteParams) => {
    const body = {
        permissionData: req
    }

    const response = await axios.post(EXPIRED_ACTIONS_EXECUTE, req);
    return response.data;
}

/** Create Expired Practice */

const getExpiredFromRaCode = async (raCode: string) => {
    const path = GET_EXPIRED_FROM_RA_CODE.replace('{raCode}', raCode);
    const response = await axios.get(path);
    return response.data;
}

const insertExpiredFromRaCode = async (raCode: string) => {
    const response = await axios.post(INSERT_EXPIRED_FROM_RA_CODE, null, {params: {raCode}});
    return response.data;
}

/** Attachment File */
const fetchAttachmentsList = async (expiredId: string) => {
    const response = await axios.get(EXPIRED_ATTACHMENTS_LIST.replace('{expiredId}', expiredId));
    return response.data;
}

const fetchExpiredAttachmentsTypes = async () => {
    const response = await axios.get(EXPIRED_ATTACHMENTS_TYPES);
    return response.data;
}

const fetchExpiredAttachmentsDownload = async (id: string) => {
    const response = await axios.get(EXPIRED_ATTACHMENTS_DOWNLOAD.replace('{id}', id), {
        responseType: "blob"
    });
    return response.data;
}

const fetchExpiredAttachmentsUpload = async (data: any) => {
    const response = await axios.post(EXPIRED_ATTACHMENTS_UPLOAD, data, {headers: { "Content-Type": "multipart/form-data" }});
    return response.data;
}

const fetchExpiredAttachmentsDelete = async (id: string) => {
    const response = await axios.delete(EXPIRED_ATTACHMENT_DELETE_BY_ID.replace('{id}', id));
    return response.data;
}

/** Warning Letter */
const generateWarningLetter = async (expiredCode: string) => {
    const response = await axios.post(
        EXPIRED_GENERATE_WARNING_LETTER,
        null, 
        {
            params: {expiredCode},
            responseType: "blob"
        }
    );

    return response.data;
}

export {
    fetchPracticesList,
    fetchPracticesListSummary,
    getPracticesDomains,
    closeSelectedPractices,
    fetchExpiredPricticeById,
    fetchAttachmentsList,
    fetchExpiredAttachmentsTypes,
    fetchExpiredAttachmentsDownload,
    fetchExpiredAttachmentsUpload,
    fetchExpiredAttachmentsDelete,
    fetchExpiredPracticeActionHistoryById,
    findExpiredConfiguration,
    updateExpiredConfiguration,
    getExpiredActions,
    getExpiredActionsMessageTemplate,
    executeExpiredAction,
    updateActionDates,
    addToWatchlist,
    findRecoveryCompany,
    saveRecoveryCompany,
    downloadPivot,
    downloadExpiredPractices,
    downloadExpiredPracticesCount,
    getExpiredActionsForView,
    getExpiredFromRaCode,
    insertExpiredFromRaCode,
    generateWarningLetter
}